import React, { useState } from 'react'
import ReactDOM from 'react-dom'
import { useTranslation } from 'react-i18next'

import { CookiePolicyLink } from 'components/CookiePolicyLink'
import { PrivacyPolicyLink } from 'components/PrivacyPolicyLink'
import { TermsOfUseLink } from 'components/TermsOfUseLink'

import { StyledBurgerMenu as S } from './BurgerMenu.styles'

export const BurgerMenu: React.FC = ({ ...props }) => {
  const { t } = useTranslation()

  const [isMenuVisible, setIsMenuVisible] = useState<boolean>(false)

  const toggleMenuVisibility = () => {
    setIsMenuVisible(!isMenuVisible)
  }

  return (
    <S.Wrapper>
      <S.Burger type="button" onClick={toggleMenuVisibility} {...props} />

      {ReactDOM.createPortal(
        <>
          <S.Backdrop
            $isMenuVisible={isMenuVisible}
            onClick={toggleMenuVisibility}
          />
          <S.Menu $isMenuVisible={isMenuVisible}>
            <S.Header>
              {t('commonComponents.docs')}
              <S.MenuCloseButton type="button" onClick={toggleMenuVisibility} />
            </S.Header>

            <TermsOfUseLink translationKey="commonComponents.termsOfService" />
            <PrivacyPolicyLink />
            <CookiePolicyLink />
          </S.Menu>
        </>,
        document.body,
      )}
    </S.Wrapper>
  )
}
